import { PerformanceIncomeDashboard } from "./PerformanceIncomeDashboard/PerformanceIncomeDashboard";
import { BonusInfoFooter } from "../../common/components/BonusInfoFooter/BonusInfoFooter";
import "./LandingPage.scss";

export const LandingPage = () => {
  return (
    <main className="LandingPage">
      <div className="LandingPage__content">
        <PerformanceIncomeDashboard />
      </div>
      <BonusInfoFooter hideDate />
    </main>
  );
};
